export const LoginForm = {
  flow: 'column',
  height: '100%',
  gap: 'C1',
  '@mobileL': {
    height: 'unset',
    align: 'center flex-start',
    width: '100%'
  },
  Flex: {
    gap: 'A',
    flow: 'column',
    childProps: {
      width: '100%',
      '@mobileL': {
        maxWidth: '100%',
        align: 'stretch',
        width: '100%'
      }
    },
    Title: null,
    Input: null,
    Identifier: {
      Title: {
        text: 'Email or username',
        padding: '- - Y'
      },
      Input: {
        height: 'B2',
        width: '100%',
        autocomplete: 'username',
        value: (el, s) => s.identifier ?? '',
        required: true,
        placeholder: 'e.g. hello@symbo.ls or username',
        round: 'Z2',
        '@mobileL': {
          width: '100%',
          height: 'unset'
        },
        onInput: (ev, el, s) => {
          s.update({
            identifier: el.node.value
          })
        }
      }
    },
    Password: {
      Title: {
        text: 'Password',
        padding: '- - X'
      },
      Input: {
        height: 'B2',
        width: '100%',
        autocomplete: 'current-password',
        value: (el, s) => s.password ?? '',
        placeholder: '••••••••',
        required: true,
        type: 'password',
        round: 'Z2',
        '@mobileL': {
          width: '100%',
          height: 'unset'
        },
        onInput: (ev, el, s) => {
          s.update({ password: el.node.value })
        }
      }
    }
  },
  ModalFooter: {
    display: 'flex',
    flow: 'row',
    width: '100%',
    maxWidth: 'unset',
    align: 'center space-between',
    gap: 'Z',
    '@mobileL': {
      flow: 'column',
      gap: 'A2',
      childProps: {
        width: '100%'
      }
    },
    CheckButton: {
      theme: 'primary',
      text: 'Sign in',
      type: 'submit',
      Icon: null,
      width: 'fit-content',
      height: 'B2',
      padding: 'Z1 B1',
      '@mobileL': {
        width: '100%',
        maxWidth: '100%',
        height: 'unset'
      }
    },
    Title: null,
    Input: null,
    DocsLink: {
      margin: '- - - auto',
      fontSize: 'Z2',
      fontWeight: '400',
      href: '/reset-password',
      text: 'Forgot your password?',
      display: 'flex',
      align: 'center center',
      '@mobileL': {
        margin: '0 auto'
      }
    }
  }
}
